import { SharedTeamGroup } from "@/domain/team/hooks/api/use-shared-team-list";
import { TeamWithoutMembershipList } from "@/domain/team/models/team-model";

interface BuildSharedTeamNavListParams {
  sharedTeamGroupList: readonly SharedTeamGroup[];
  teamList: readonly TeamWithoutMembershipList[];
  memberTeamIdSet: ReadonlySet<string>;
}

interface SharedTeamNavItem {
  team: TeamWithoutMembershipList;
  entityTypeSet: Set<string>;
}

export function buildSharedTeamNavList({
  sharedTeamGroupList,
  teamList,
  memberTeamIdSet,
}: BuildSharedTeamNavListParams): SharedTeamNavItem[] {
  const teamByIdMap = new Map<string, TeamWithoutMembershipList>(teamList.map((team) => [team.id, team]));

  return sharedTeamGroupList
    .map((sharedTeamGroup) => {
      const team = teamByIdMap.get(sharedTeamGroup.teamId);
      if (!team || memberTeamIdSet.has(sharedTeamGroup.teamId)) {
        return null;
      }

      const entityTypeSet = new Set(sharedTeamGroup.entityList.map((entity) => entity.entityType));
      return { team, entityTypeSet };
    })
    .filter((navItem): navItem is SharedTeamNavItem => navItem !== null);
}
